import type en from '../en/devices'
import type { Translation } from '../types'

/** The device brands: registering a device and its page */
const devices: Translation<typeof en> = {
  "devices.registered": "Apparaat geregistreerd",
  "devices.registrationFailed": "Registratie mislukt",
  "devices.siteRegistered": "{name} geregistreerd",
  "devices.registerAnother": "Nog een registreren",
  "devices.openDevice": "Apparaat openen",
  "devices.viewAllSites": "Alle locaties bekijken",
  "devices.deviceAddress": "Adres van het apparaat *",
  "devices.username": "Gebruikersnaam *",
  "devices.password": "Wachtwoord *",
  "devices.siteName": "Naam van de locatie",
  "devices.connectRegister": "Verbinden en registreren",
  "devices.directDevice": "Direct apparaat",
  "devices.deviceUrl": "URL van het apparaat *",
  "devices.reachableVpn": "Moet bereikbaar zijn vanaf deze server — meestal via de VPN-tunnel.",
  "devices.storedEncrypted": "Versleuteld opgeslagen.",
  "devices.imported": { one: "{count} apparaat geïmporteerd", other: "{count} apparaten geïmporteerd" },
  "devices.mikrotik.transport.rest": "REST API (RouterOS 7)",
  "devices.mikrotik.transport.apiSsl": "API-protocol via TLS",
  "devices.mikrotik.transport.api": "API-protocol (onversleuteld)",
  "devices.mikrotik.radios": { one: "{count} radio", other: "{count} radio’s" },
  "devices.mikrotik.connectedOver": "Verbonden via: {transport}",
  "devices.mikrotik.registerTitle": "MikroTik registreren",
  "devices.mikrotik.registerSubtitle": "Een router, access point of punt-tot-punt-/punt-tot-multipuntradio",
  "devices.mikrotik.addressHint": "Moet bereikbaar zijn vanaf deze server — meestal het VPN-adres. Het verbindingstype wordt herkend: REST op RouterOS 7, de API-service (8729 of 8728) op RouterOS 6.43 en nieuwer.",
  "devices.mikrotik.forceHint": "Om er een af te dwingen, schrijft u",
  "devices.or": "of",
  "devices.mikrotik.accountHint": "Gebruik een account met volledige rechten als u het apparaat hiervandaan wilt configureren; voor monitoring volstaat een account met alleen leesrechten. Versleuteld opgeslagen.",
  "devices.mikrotik.siteNameHint": "(optioneel — standaard de identiteit van het apparaat)",
  "devices.mikrotik.siteNamePlaceholder": "bijv. Sector noord",
  "devices.mikrotik.radioLinkTitle": "Voor een straalverbinding",
  "devices.mikrotik.radioLinkText": " registreert u elk uiteinde als een eigen locatie. Het access point toont dan elk station met signaal en snelheid; een station dat hier ook is geregistreerd, wordt zelfs op een gewoon wifi-access point als verbinding herkend.",
  "devices.peplink.foundOrgs": { one: "{count} organisatie gevonden", other: "{count} organisaties gevonden" },
  "devices.peplink.discoveryFailed": "Zoeken mislukt",
  "devices.peplink.telemetryNote": "SpeedFusion- en WAN-telemetrie verschijnen na de eerste synchronisatie.",
  "devices.peplink.registerTitle": "Peplink registreren",
  "devices.peplink.registerSubtitle": "Verbinden via InControl2 of rechtstreeks met een router",
  "devices.peplink.ic2Desc": "Importeert elk apparaat in een organisatie of groep.",
  "devices.peplink.directDesc": "Bevraagt één Balance/MAX-router lokaal.",
  "devices.peplink.clientId": "Client-ID *",
  "devices.peplink.clientSecret": "Clientgeheim *",
  "devices.createUnder": "Maak aan onder",
  "devices.peplink.ic2Url": "IC2 API-URL",
  "devices.peplink.discoverOrgs": "Organisaties zoeken",
  "devices.peplink.organisation": "Organisatie *",
  "devices.peplink.group": "Groep",
  "devices.peplink.blankAllGroups": "(leeg = alle groepen)",
  "devices.peplink.allGroups": "Alle groepen",
  "devices.peplink.siteNamePlaceholder": "bijv. Boot 1 — MAX Transit",
  "devices.teltonika.importedFromRms": { one: "{count} apparaat geïmporteerd uit RMS", other: "{count} apparaten geïmporteerd uit RMS" },
  "devices.teltonika.telemetryNote": "Mobiele telemetrie verschijnt na de eerste synchronisatie.",
  "devices.teltonika.registerTitle": "Teltonika registreren",
  "devices.teltonika.registerSubtitle": "Verbinden via de RMS-cloud of rechtstreeks met een router",
  "devices.teltonika.rmsCloud": "RMS-cloud",
  "devices.teltonika.rmsDesc": "Importeert elk apparaat in uw RMS-bedrijf. Het best voor vloten.",
  "devices.teltonika.directDesc": "Bevraagt één RutOS-router via zijn lokale API.",
  "devices.teltonika.pat": "Persoonlijk toegangstoken *",
  "devices.teltonika.createInRms": "Maak aan in RMS onder",
  "devices.teltonika.rmsUrl": "RMS API-URL",
  "devices.teltonika.defaultRms": "Leeg laten voor de standaard openbare RMS.",
  "devices.teltonika.siteNamePlaceholder": "bijv. Bus 3 — RUTX11",
  "devices.unifihost.consoles": { one: "{count} console", other: "{count} consoles" },
  "devices.unifihost.found": "{consoles} en {sites} gevonden",
  "devices.unifihost.verificationFailed": "Verificatie mislukt",
  "devices.unifihost.importedSites": { one: "{count} locatie geïmporteerd", other: "{count} locaties geïmporteerd" },
  "devices.unifihost.importFailed": "Importeren mislukt",
  "devices.unifihost.doneNote": "Site Manager geeft alleen-lezen telemetrie van de vloot en ISP-statistieken. Voeg voor configuratie ook de lokale controller toe als UniFi-locatie.",
  "devices.unifihost.importMore": "Meer importeren",
  "devices.unifihost.title": "UniFi Site Manager koppelen",
  "devices.unifihost.subtitle": "Monitoring van de hele vloot over elke UniFi-console in uw account",
  "devices.unifihost.apiKey": "API-sleutel *",
  "devices.unifihost.apiKeyPlaceholder": "API-sleutel van UniFi Site Manager",
  "devices.unifihost.createAt": "Maak aan op",
  "devices.unifihost.baseUrl": "Basis-URL van de API",
  "devices.unifihost.verifyDiscover": "Controleren en zoeken",
  "devices.unifihost.importAs": "Importeren als",
  "devices.unifihost.perSite": "Eén locatie per UniFi-site",
  "devices.unifihost.recommended": "{sites} — aanbevolen",
  "devices.unifihost.perConsole": "Eén locatie per console",
  "devices.unifihost.consolesToImport": "Te importeren consoles",
  "devices.unifihost.console": "console",
  "devices.unifihost.importConsoles": { one: "{count} console importeren", other: "{count} consoles importeren" },
  "devices.velanox.registeredFromEndpoint": { one: "{count} box geregistreerd vanaf het endpoint", other: "{count} boxen geregistreerd vanaf het endpoint" },
  "devices.velanox.standaloneRegistered": "Losse box geregistreerd: {name}",
  "devices.velanox.boxesRegistered": { one: "{count} box geregistreerd", other: "{count} boxen geregistreerd" },
  "devices.velanox.boxRegistered": "Box geregistreerd",
  "devices.velanox.endpointNote": "Er is een locatie gemaakt voor elke box op het endpoint. Ze synchroniseren automatisch.",
  "devices.velanox.boxNote": "De losse box is als locatie toegevoegd.",
  "devices.velanox.registerTitle": "Velanox-locatie registreren",
  "devices.velanox.registerSubtitle": "Koppel een Velanox One Speed-endpoint of een losse box",
  "devices.velanox.endpoint": "Endpoint",
  "devices.velanox.endpointDesc": "Bundelt meerdere boxen. Maakt automatisch één locatie per box.",
  "devices.velanox.standalone": "Losse box",
  "devices.velanox.standaloneDesc": "Eén box die rechtstreeks wordt bevraagd.",
  "devices.velanox.endpointName": "Naam van het endpoint",
  "devices.velanox.endpointNamePlaceholder": "bijv. Endpoint Amsterdam",
  "devices.velanox.endpointNameHint": "Gebruikt als label — de namen van de afzonderlijke boxen komen uit de API.",
  "devices.velanox.siteNamePlaceholder": "bijv. Starlinkhuren mobiele unit",
  "devices.velanox.url": "Velanox-URL *",
  "devices.velanox.baseUrlEndpoint": "Basis-URL van de Flask-server van het endpoint.",
  "devices.velanox.baseUrlBox": "Basis-URL van de HTTP-server van de losse box.",
  "devices.velanox.token": "Integratietoken *",
  "devices.velanox.setVia": "In te stellen via",
  "devices.velanox.onNode": "op de Velanox-node.",
  "devices.velanox.descriptionPlaceholder": "Optionele notities over deze verbinding",
  "devices.actionFailed": "Actie mislukt",
  "devices.actionSent": "\"{action}\" verstuurd",
  "devices.action.reboot": "herstarten",
  "devices.action.firmware_check": "firmwarecontrole",
  "devices.action.tunnel_reconnect": "tunnel opnieuw verbinden",
  "devices.action.wan_enable": "WAN inschakelen",
  "devices.action.wan_disable": "WAN uitschakelen",
  "devices.action.send_sms": "sms versturen",
  "devices.action.restart_modem": "modem herstarten",
  "devices.action.switch_sim": "simkaart wisselen",
  "devices.action.restart_network": "netwerk herstarten",
  "devices.action.roll_key": "sleutel vernieuwen",
  "devices.action.restart_service": "service herstarten",
  "devices.action.get_stats": "statistieken ophalen",
  "devices.action.fetch_logs": "logs ophalen",
  "devices.action.starlink_stow": "schotel opbergen",
  "devices.action.starlink_unstow": "schotel uitklappen",
  "devices.action.starlink_reboot": "schotel herstarten",
  "devices.upFor": "actief {duration}",
  "devices.memory": "Geheugen",
  "devices.temperature": "Temperatuur",
  "devices.openMap": "Kaart openen",
  "devices.controls": "Apparaatbediening",
  "devices.checkFirmware": "Firmware controleren",
  "devices.sendSms": "Sms versturen",
  "devices.reboot": "Herstarten",
  "devices.sms.recipient": "Nummer van de ontvanger",
  "devices.sms.message": "Bericht",
  "devices.sms.charges": "Verstuurd vanaf de simkaart van de router. Er gelden kosten van de provider.",
  "devices.signal.0": "Geen signaal",
  "devices.signal.1": "Zeer slecht",
  "devices.signal.2": "Slecht",
  "devices.signal.3": "Redelijk",
  "devices.signal.4": "Goed",
  "devices.signal.5": "Uitstekend",
  "devices.unknown": "onbekend",
  "devices.unknownError": "Onbekende fout",
  "devices.up": "Actief",
  "devices.connected": "Verbonden",
  "devices.loss": "{percent}% verlies",
  "devices.interface": "Interface",
  "devices.ipAddress": "IP-adres",
  "devices.gateway": "Gateway",
  "devices.enable": "Inschakelen",
  "devices.disable": "Uitschakelen",
  "devices.device": "Apparaat",
  "devices.firmware": "Firmware",
  "devices.mikrotik.updateCheckDone": "Updatecontrole klaar",
  "devices.mikrotik.installedLatest": "Geïnstalleerd {installed}, nieuwste {latest}",
  "devices.mikrotik.noNewer": "Geen nieuwere versie gemeld",
  "devices.mikrotik.backupSaved": "Back-up opgeslagen",
  "devices.mikrotik.rebootSent": "Herstart verstuurd",
  "devices.mikrotik.backInMinute": "Het apparaat is over een minuut of twee terug.",
  "devices.mikrotik.renamePrompt": "Naam voor deze verbinding",
  "devices.mikrotik.renameFailed": "Hernoemen mislukt",
  "devices.mikrotik.forgetConfirm": "{name} vergeten? Gebruik dit voor een station dat bewust is verwijderd — het komt vanzelf terug als het opnieuw verbinding maakt.",
  "devices.mikrotik.forgetFailed": "Kon de verbinding niet verwijderen",
  "devices.mikrotik.device": "MikroTik-apparaat",
  "devices.mikrotik.updateBadge": "update {version}",
  "devices.mikrotik.via": "via {transport}",
  "devices.mikrotik.configure": "Configureren",
  "devices.mikrotik.checkUpdates": "Updates controleren",
  "devices.mikrotik.backup": "Back-up",
  "devices.mikrotik.rebootConfirm": "Dit apparaat herstarten? Verbindingen via dit apparaat vallen een minuut of twee weg.",
  "devices.mikrotik.cannotReach": "Het apparaat is niet bereikbaar{reason}. De verbindingen hieronder zijn zoals laatst gezien.",
  "devices.mikrotik.links": "Verbindingen",
  "devices.mikrotik.wifiClients": { one: "{count} wificlient", other: "{count} wificlients" },
  "devices.mikrotik.radioLinks": "Straalverbindingen",
  "devices.mikrotik.noLinks": "Nog geen verbindingen gezien. Ze verschijnen na de eerste synchronisatie zodra er een station verbonden is.",
  "devices.mikrotik.farEnd": "Andere kant",
  "devices.mikrotik.signal": "Signaal",
  "devices.mikrotik.rate": "Snelheid ↑ / ↓",
  "devices.mikrotik.quality": "Kwaliteit",
  "devices.mikrotik.distance": "Afstand",
  "devices.mikrotik.roleAp": "access point",
  "devices.mikrotik.roleStation": "station",
  "devices.mikrotik.onInterface": "op {interface}",
  "devices.mikrotik.linkDown": "verbinding weg",
  "devices.mikrotik.seen": "gezien {when}",
  "devices.mikrotik.rename": "Hernoemen",
  "devices.mikrotik.forget": "Deze verbinding vergeten",
  "devices.mikrotik.noWireless": "Geen draadloze interfaces",
  "devices.mikrotik.mode": "Modus",
  "devices.mikrotik.channel": "Kanaal",
  "devices.mikrotik.state": "Toestand",
  "devices.mikrotik.disabled": "uitgeschakeld",
  "devices.mikrotik.running": "actief",
  "devices.mikrotik.notConnected": "niet verbonden",
  "devices.mikrotik.uplinks": "Uplinks",
  "devices.mikrotik.noUplink": "Geen uplink gevonden. Een interface telt als uplink als zij in de interfacelijst “WAN” staat of de standaardroute draagt.",
  "devices.mikrotik.address": "Adres",
  "devices.mikrotik.order": "Volgorde",
  "devices.mikrotik.signalAria": "signaal {percent} procent",
  "devices.peplink.cannotReach": "Het Peplink-apparaat is niet bereikbaar — controleer de inloggegevens",
  "devices.peplink.wansUp": "WAN’s actief",
  "devices.peplink.tunnels": "SpeedFusion-tunnels",
  "devices.storedLine": "Laatst gelezen {when} — de router wordt nu gelezen…",
  "devices.storedLineNever": "Nog niet gelezen — de router wordt nu gelezen…",
  "devices.peplink.wanLinks": "WAN-verbindingen",
  "devices.peplink.unknownCarrier": "Onbekende provider",
  "devices.peplink.rebootConfirm": "Dit Peplink-apparaat herstarten? Alle verbindingen vallen 1-2 minuten weg.",
  "devices.teltonika.cannotReach": "Het Teltonika-apparaat is niet bereikbaar — controleer de inloggegevens en de verbinding",
  "devices.teltonika.modems": "Modems",
  "devices.teltonika.power.title": "Stroom",
  "devices.teltonika.power.noBattery": "Geen accu",
  "devices.teltonika.power.onMains": "Op netstroom",
  "devices.teltonika.power.onBattery": "Op noodstroom sinds {time} ({duration})",
  "devices.teltonika.power.notKnown": "Niet bekend",
  "devices.teltonika.power.has": "Heeft noodstroom (UPS)",
  "devices.teltonika.power.notChanged": "De instelling voor noodstroom is niet gewijzigd",
  "devices.teltonika.noModems": "Geen mobiele modems gemeld",
  "devices.teltonika.noOperator": "Geen provider",
  "devices.teltonika.band": "Band {band}",
  "devices.teltonika.dataUsage": "Dataverbruik",
  "devices.teltonika.restartModem": "Modem herstarten",
  "devices.teltonika.switchSimConfirm": "{modem} naar de andere simsleuf wisselen?",
  "devices.teltonika.switchSim": "Simkaart wisselen",
  "devices.teltonika.wanInterfaces": "WAN-interfaces",
  "devices.teltonika.noWans": "Geen WAN-interfaces gemeld",
  "devices.teltonika.rebootConfirm": "Dit apparaat herstarten? Het is 1-2 minuten offline.",
  "devices.teltonika.vpnMode": "Op de werkbank geprogrammeerd",
  "devices.teltonika.vpnModeDesc": "Op serienummer, met een eigen VPN-certificaat",
  "devices.teltonika.serial": "Serienummer",
  "devices.teltonika.serialHint": "Zoals op het label; spaties maken niet uit. Hetzelfde serienummer nog eens vernieuwt deze router en geeft hem een nieuw certificaat.",
  "devices.teltonika.model": "Model",
  "devices.teltonika.modelHint": "Het model mag leeg blijven: de router meldt zijn eigen model bij de eerste verbinding.",
  "devices.teltonika.vpnLogin": "Velanox-login op de router",
  "devices.teltonika.vpnLoginHint": "De gebruiker waarmee Velanox via de tunnel inlogt. Het wachtwoord wordt versleuteld opgeslagen en nooit meer getoond.",
  "devices.teltonika.addRouter": "Router toevoegen",
  "devices.teltonika.routerAdded": "Router toegevoegd",
  "devices.teltonika.routerAddedText": "Het VPN-certificaat is uitgegeven: zet het .ovpn-bestand vanaf deze pagina op de router.",
  "devices.teltonika.addFailed": "De router is niet toegevoegd",
  "devices.teltonika.vpn.waiting": "Wacht op de router",
  "devices.teltonika.vpn.noAccount": "Deze router heeft nog geen VPN-certificaat: voeg hem opnieuw toe met hetzelfde serienummer om er een uit te geven.",
  "devices.teltonika.vpn.newCertConfirm": "Een nieuw VPN-certificaat uitgeven voor {name}? Het huidige werkt meteen niet meer; de router blijft van de VPN af tot hij het nieuwe bestand heeft.",
  "devices.teltonika.vpn.newCertDoneText": "Download het nieuwe .ovpn-bestand en zet het op de router.",
  "devices.teltonika.vpn.stepsTitle": "Op de router zetten (RutOS-WebUI)",
  "devices.teltonika.vpn.step1": "Services → VPN → OpenVPN: voeg een client-instantie toe met de naam velanox.",
  "devices.teltonika.vpn.step2": "Zet hem aan, zet “{option}” aan en kies {file}. Opslaan.",
  "devices.teltonika.vpn.step3": "De router belt in; deze kaart toont binnen een paar minuten Verbonden.",
  "devices.unifihost.consoleName": "UniFi-console",
  "devices.unifihost.readOnly": "Cloudweergave, alleen-lezen. Registreer de lokale controller als UniFi-locatie om instellingen te wijzigen.",
  "devices.unifihost.online": "online",
  "devices.unifihost.offline": "offline",
  "devices.unifihost.onConsole": "op deze console",
  "devices.unifihost.connected": "verbonden",
  "devices.unifihost.updates": "Updates",
  "devices.unifihost.firmwareAvailable": "firmware beschikbaar",
  "devices.unifihost.ispPerformance": "ISP-prestaties",
  "devices.unifihost.last24h": "Laatste 24 u",
  "devices.unifihost.last30d": "Laatste 30 d",
  "devices.unifihost.noIsp": "Geen ISP-statistieken gemeld voor deze console",
  "devices.unifihost.updateBadge": "⬆ update",
  "devices.velanox.cannotReach": "De Velanox-box is niet bereikbaar — controleer het integratietoken en de URL",
  "devices.velanox.keyRollPending": "🔑 Sleutelvernieuwing in afwachting",
  "devices.velanox.wans": { one: "{count} WAN", other: "{count} WAN’s" },
  "devices.velanox.encrypted": "🔒 versleuteld",
  "devices.velanox.na": "n.v.t.",
  "devices.velanox.rttBonded": "RTT (gebundeld)",
  "devices.velanox.packetLoss": "Pakketverlies",
  "devices.velanox.wanPaths": "WAN-paden",
  "devices.velanox.noWanPaths": "Geen WAN-paden",
  "devices.velanox.jitter": "Jitter",
  "devices.velanox.loss": "Verlies",
  "devices.velanox.weight": "Gewicht",
  "devices.velanox.anchor": "Anker",
  "devices.velanox.alive": "Actief",
  "devices.velanox.roaming": "Roaming",
  "devices.velanox.boxControls": "Boxbediening",
  "devices.velanox.controlsNote": "Bedieningsacties worden via het beheerkanaal naar de box doorgegeven. Herstarten veroorzaakt een korte storing.",
  "devices.velanox.rollKey": "Sleutel vernieuwen",
  "devices.velanox.restartService": "Service herstarten",
  "devices.velanox.getStats": "Statistieken ophalen",
  "devices.velanox.fetchLogs": "Logs ophalen",
  "devices.velanox.rebootBox": "Box herstarten",
  "devices.velanox.rebootConfirm": "Deze Velanox-box herstarten? Dit veroorzaakt een korte storing.",
  "devices.velanox.starlinkUnavailable": "De Starlink-status is niet beschikbaar{reason}.",
  "devices.velanox.loadingStarlink": "Starlink-status laden…",
  "devices.velanox.noDriver": "Er is geen Starlink-driver gekoppeld aan deze box. De box meldt driver: null.",
  "devices.velanox.capabilities": "Starlink-mogelijkheden",
  "devices.velanox.driver": "Driver: {driver}",
  "devices.velanox.reposition": "Herpositioneren is nooit beschikbaar op echte Starlink-hardware — schotels richten zichzelf.",
  "devices.velanox.dishControls": "Schotelbediening",
  "devices.velanox.greyedNote": "Knoppen zijn grijs als de schotel die mogelijkheid niet ondersteunt.",
  "devices.velanox.grpcNote": "Let op: schotelbediening via het endpoint geeft 501 (integratie volgt). Gebruik de modus losse box voor schotelbediening.",
  "devices.velanox.stow": "Schotel opbergen",
  "devices.velanox.unstow": "Schotel uitklappen",
  "devices.velanox.rebootDish": "Schotel herstarten",
  "devices.velanox.rebootDishConfirm": "De Starlink-schotel herstarten?",
  "devices.velanox.dishStatus": "Schotelstatus",
  "devices.velanox.notSupported": "{label} wordt niet ondersteund door deze box",
  "devices.velanox.preset.firmware": "Firmwarestatus",
  "devices.velanox.preset.gateway": "Gatewaystatus",
  "devices.velanox.preset.firewall": "Firewallregels",
  "devices.velanox.preset.dhcp": "DHCP-leases",
  "devices.velanox.preset.interfaces": "Interfaces",
  "devices.velanox.preset.arp": "ARP-tabel",
  "devices.velanox.invalidJson": "De body is geen geldige JSON",
  "devices.velanox.requestFailed": "Verzoek mislukt",
  "devices.velanox.passThrough": "OPNsense-doorgifte. De box handhaaft het ingestelde toegangsniveau — geweigerde aanroepen geven 403. Niveau 3 kan de firewall herstarten of herconfigureren.",
  "devices.velanox.quickPresets": "Snelle voorinstellingen",
  "devices.velanox.httpMethod": "HTTP-methode",
  "devices.velanox.apiPath": "API-pad",
  "devices.velanox.requestBody": "Body van het verzoek (JSON, optioneel)",
  "devices.velanox.response": "Antwoord",
  "devices.unifihost.connectedSince": "Verbonden sinds",
  "devices.unifihost.managedBy": "Beheerd door",
  "devices.unifihost.mgmt.GATEWAY": "Gateway",
  "devices.unifihost.mgmt.SWITCH": "Switch",
  "devices.unifihost.mgmt.UNMANAGED": "Niet beheerd",
  "devices.unifihost.defaultNetwork": "standaard",
  "devices.unifihost.security": "Beveiliging",
  "devices.unifihost.bands": "Banden",
  "devices.unifihost.network": "Netwerk",
  "devices.unifihost.nativeNetwork": "Standaardnetwerk",
  "devices.unifihost.sec.OPEN": "Open",
  "devices.unifihost.sec.WPA2_PERSONAL": "WPA2-Personal",
  "devices.unifihost.sec.WPA3_PERSONAL": "WPA3-Personal",
  "devices.unifihost.sec.WPA2_WPA3_PERSONAL": "WPA2/WPA3-Personal",
  "devices.unifihost.sec.WPA2_ENTERPRISE": "WPA2-Enterprise",
  "devices.unifihost.sec.WPA3_ENTERPRISE": "WPA3-Enterprise",
  "devices.unifihost.sec.WPA2_WPA3_ENTERPRISE": "WPA2/WPA3-Enterprise",
  "devices.unifihost.why.rejected": "UniFi weigerde de API-sleutel voor deze console. De sleutel moet van de eigenaar van de console zijn.",
  "devices.unifihost.why.unsupported": "Deze console kan deze lijst niet via de cloud geven. Daarvoor is UniFi OS 5.0.3 of nieuwer nodig, en voor netwerken en wifi UniFi Network 10 of nieuwer.",
  "devices.unifihost.why.busy": "UniFi beperkt het aantal verzoeken aan deze console. Probeer het over een minuut opnieuw.",
  "devices.unifihost.why.unreachable": "De console antwoordde niet via de cloud. Controleer of deze online is.",
  "devices.unifihost.why.no_match": "Deze UniFi-site staat niet meer op de console.",
  "devices.unifihost.why.failed": "UniFi gaf deze lijst niet.",
  "devices.unifilocal.open": "Zo schakelt u over →",
  "devices.unifilocal.title": "Overschakelen naar de lokale controller",
  "devices.unifilocal.intro": "De console maakt verbinding met het dashboard via een eigen VPN-tunnel; het dashboard leest en wijzigt hem daarna via zijn eigen controller. De locatie behoudt haar naam, meldingen en abonnementen.",
  "devices.unifilocal.noPermission": "Voor het overschakelen zijn de rechten nodig om locaties te bewerken en de VPN te beheren.",
  "devices.unifilocal.step.account": "Maak het VPN-account van deze locatie aan",
  "devices.unifilocal.step.accountText": "Het account geeft de console een eigen certificaat en een vast adres in het VPN-netwerk van het bedrijf.",
  "devices.unifilocal.createAccount": "VPN-account aanmaken",
  "devices.unifilocal.creating": "Account wordt aangemaakt…",
  "devices.unifilocal.accountReady": "Klaar: tunneladres {ip}",
  "devices.unifilocal.accountFailed": "Het VPN-account kon niet worden aangemaakt",
  "devices.unifilocal.step.download": "Download het VPN-bestand",
  "devices.unifilocal.step.downloadText": "Het .ovpn-bestand bevat het eigen certificaat van deze locatie. Houd het privé en gebruik het alleen op deze console.",
  "devices.unifilocal.download": ".ovpn downloaden",
  "devices.unifilocal.downloadFailed": "Downloaden mislukt",
  "devices.unifilocal.step.client": "Voeg het in UniFi toe als VPN-client",
  "devices.unifilocal.client.1": "Open in UniFi Network Settings → VPN → VPN Client en kies Create New.",
  "devices.unifilocal.client.2": "VPN-type: OpenVPN. Geef het een naam, bijvoorbeeld Velanox.",
  "devices.unifilocal.client.3": "Upload het .ovpn-bestand als configuratiebestand.",
  "devices.unifilocal.client.4": "Laat gebruikersnaam en wachtwoord leeg: het bestand bevat het certificaat.",
  "devices.unifilocal.client.5": "Stuur er geen verkeer doorheen: laat de routeringswizards uit en voeg geen verkeersroute toe. Alleen het dashboard gebruikt deze tunnel.",
  "devices.unifilocal.client.6": "Kies Create. De verbinding komt binnen een minuut tot stand.",
  "devices.unifilocal.waiting": "Wachten tot de tunnel verbonden is…",
  "devices.unifilocal.connected": "Tunnel verbonden",
  "devices.unifilocal.step.firewall": "Laat het dashboard de console bereiken",
  "devices.unifilocal.firewall.why": "UniFi plaatst een VPN-clientverbinding in de zone External, die de console zelf niet bereikt. Voeg een firewallbeleid toe dat het dashboard binnenlaat:",
  "devices.unifilocal.firewall.1": "UniFi Network 10: Settings → Policy Engine → Policy Table → Create New Policy. Oudere versies: Settings → Security → Firewall.",
  "devices.unifilocal.firewall.2": "Bron: zone External, IP-adres {ip}.",
  "devices.unifilocal.firewall.3": "Bestemming: zone Gateway, poort 443 (TCP).",
  "devices.unifilocal.firewall.4": "Actie: Allow.",
  "devices.unifilocal.serverIpFallback": "het tunneladres van het dashboard (het eerste adres van het locatienetwerk)",
  "devices.unifilocal.step.key": "Maak een lokale API-sleutel aan",
  "devices.unifilocal.key.1": "In UniFi Network: Settings → Control Plane → Integrations → Create API Key.",
  "devices.unifilocal.key.2": "Kopieer de sleutel: UniFi toont hem maar één keer.",
  "devices.unifilocal.step.switch": "Schakel de locatie over naar haar lokale controller",
  "devices.unifilocal.apiKey": "Lokale API-sleutel",
  "devices.unifilocal.controllerUrl": "Adres van de controller",
  "devices.unifilocal.controllerHint": "Ingevuld op basis van het tunneladres. Een zelf gehoste UniFi Network Server: https://<adres>:8443",
  "devices.unifilocal.testSwitch": "Testen en overschakelen",
  "devices.unifilocal.testing": "Testen…",
  "devices.unifilocal.done": "De locatie gebruikt nu haar lokale controller",
  "devices.unifilocal.why.rejected": "De console weigerde deze API-sleutel. Maak een nieuwe aan onder Control Plane → Integrations.",
  "devices.unifilocal.why.not_found": "De console antwoordde, maar niet op dit adres. Een zelf gehoste UniFi Network Server gebruikt https://<adres>:8443.",
  "devices.unifilocal.why.unreachable": "De console antwoordde niet via de tunnel. Controleer of de VPN-client verbonden is (stap 3) en of het firewallbeleid het dashboard binnenlaat (stap 4).",
  "devices.unifilocal.why.no_vpn": "Deze locatie heeft nog geen tunneladres (stap 1).",
  "devices.unifilocal.why.failed": "De test is niet gelukt. Controleer het adres en de API-sleutel.",
  "devices.unifilocal.manual.intro": "Een UniFi OS-console (Dream Machine, Cloud Gateway, Cloud Key) maakt verbinding als OpenVPN-client met het .ovpn-bestand van zijn locatie, ongewijzigd geüpload.",
  "devices.unifilocal.manual.download": "Download het .ovpn-bestand van de locatie",
  "devices.unifilocal.manual.downloadText": "In de tabel met VPN-accounts hierboven, op de regel van de locatie.",
  "devices.unifilocal.manual.add": "Voeg de locatie toe in het dashboard",
  "devices.unifilocal.manual.addText": "Een locatie die via Site Manager is toegevoegd: open haar en kies de blauwe balk; die schakelt de locatie samen met u over. Een nieuwe locatie: voeg een UniFi-locatie toe met het controlleradres https://<tunneladres>/proxy/network en de lokale API-sleutel.",
  "devices.mikrotik.vpnModeHint": "Velanox geeft de unit een eigen VPN-certificaat. Zet dat op de unit; zodra de unit verbinding maakt, leest Velanox hem uit via zijn tunnel. Er hoeft nu niets bereikbaar te zijn.",
  "devices.mikrotik.serial": "Serienummer",
  "devices.mikrotik.serialHint": "Zoals op het label; spaties en hoofdletters maken niet uit. Hetzelfde serienummer nog eens vernieuwt deze unit en geeft hem een nieuw certificaat.",
  "devices.mikrotik.unitRoleLabel": "Rol",
  "devices.mikrotik.unitRoleNone": "Geen",
  "devices.mikrotik.unitRole.SENDER": "Zender",
  "devices.mikrotik.unitRole.RECEIVER": "Ontvanger",
  "devices.mikrotik.unitNameHint": "(optioneel — anders het serienummer)",
  "devices.mikrotik.vpnAccountHint": "Het account waarmee Velanox via de tunnel inlogt. Versleuteld opgeslagen, nooit meer getoond.",
  "devices.mikrotik.addUnit": "MikroTik toevoegen",
  "devices.mikrotik.unitAdded": "MikroTik toegevoegd",
  "devices.mikrotik.unitAddedText": "Het VPN-certificaat is uitgegeven: zet de bestanden vanaf deze pagina op de unit.",
  "devices.mikrotik.addFailed": "De MikroTik is niet toegevoegd",
  "devices.mikrotik.notDeployed.waiting": "Wacht op VPN",
  "devices.mikrotik.notDeployed.offline": "Offline · niet uitgerold",
  "devices.mikrotik.waitingText": "De unit heeft nog geen verbinding met de VPN; zodra hij verbinding maakt, leest Velanox hem uit via zijn tunnel.",
  "devices.mikrotik.vpn.connected": "Verbonden",
  "devices.mikrotik.vpn.waiting": "Wacht op de unit",
  "devices.mikrotik.vpn.noAccount": "Deze unit heeft nog geen VPN-certificaat: voeg hem opnieuw toe met hetzelfde serienummer om er een uit te geven.",
  "devices.mikrotik.vpn.tunnelAddress": "Tunneladres",
  "devices.mikrotik.vpn.lastSeen": "Laatst verbonden",
  "devices.mikrotik.vpn.never": "Nooit",
  "devices.mikrotik.vpn.downloadOvpn": ".ovpn downloaden",
  "devices.mikrotik.vpn.downloadP12": ".p12 downloaden",
  "devices.mikrotik.vpn.newCert": "Nieuw certificaat",
  "devices.mikrotik.vpn.newCertConfirm": "Een nieuw VPN-certificaat uitgeven voor {name}? Het huidige werkt meteen niet meer; de unit blijft van de VPN af tot hij de nieuwe bestanden heeft.",
  "devices.mikrotik.vpn.newCertDone": "Nieuw certificaat uitgegeven",
  "devices.mikrotik.vpn.newCertDoneText": "Download de nieuwe bestanden en zet ze op de unit.",
  "devices.mikrotik.vpn.newCertFailed": "Er is geen nieuw certificaat uitgegeven",
  "devices.mikrotik.vpn.passphrase": "Wachtwoordzin van deze .p12:",
  "devices.mikrotik.vpn.passphraseHint": "Eenmalig getoond, alleen voor deze download; hij wordt niet bewaard. Elke download krijgt een nieuwe.",
  "devices.mikrotik.vpn.passphraseWord": "wachtwoordzin",
  "devices.mikrotik.vpn.commands": "Opdrachten voor RouterOS 7.17 of nieuwer",
  "devices.mikrotik.vpn.commandsHint": "Upload beide bestanden naar de unit (Files) en plak deze daarna in zijn terminal.",
  "devices.mikrotik.band.open": "Aan of uit zetten, frequentie wijzigen",
  "devices.mikrotik.band.on": "Radio aan",
  "devices.mikrotik.band.frequency": "Frequentie",
  "devices.mikrotik.band.auto": "Automatisch",
  "devices.mikrotik.band.channel": "{mhz} MHz · kanaal {n}",
  "devices.mikrotik.band.followsAp": "Een station volgt de frequentie van zijn access point",
  "devices.mikrotik.band.offWarning": "{name} draagt een radioverbinding. Uitzetten verbreekt die verbinding: de unit aan de andere kant is er dan niet meer via bereikbaar. Raakt deze unit zelf ook onbereikbaar, dan zet hij de radio na 10 minuten zelf weer aan. {name} uitzetten?",
  "devices.mikrotik.band.applied": "Radio-instellingen toegepast",
  "devices.mikrotik.band.applying": "Bezig met toepassen. Verbreekt de wijziging de verbinding, dan kan dit twee minuten duren.",
  "devices.mikrotik.band.apply": "Toepassen",
  "devices.vpnPath": "Bereikt via de eigen VPN-verbinding: laad na het toevoegen het .ovpn-bestand van de locatie op de router als OpenVPN-client. Er hoeft nu niets bereikbaar te zijn.",
  "devices.vpnAdded": "Locatie toegevoegd",
  "devices.vpnAddedText": "Laad het .ovpn-bestand op de router; de locatie komt online zodra die verbindt",
  "devices.teltonika.sim.title": "Simkaart",
  "devices.teltonika.sim.slot": "Sim {slot}",
  "devices.teltonika.sim.active": "Actief",
  "devices.teltonika.sim.locked": "Vergrendeld met pincode",
  "devices.teltonika.sim.unlocked": "Niet vergrendeld",
  "devices.teltonika.sim.blocked": "Geblokkeerd: PUK-code nodig",
  "devices.teltonika.sim.unknown": "Onbekend",
  "devices.teltonika.sim.pinTries": "Resterende pinpogingen: {count}",
  "devices.teltonika.sim.pukTries": "Resterende PUK-pogingen: {count}",
  "devices.teltonika.sim.usesCompany": "Bedrijfspincode",
  "devices.teltonika.sim.usesOwn": "Eigen pincode",
  "devices.teltonika.sim.usesOwnNote": "Eigen pincode · {note}",
  "devices.teltonika.sim.usesNone": "Geen pincode bekend",
  "devices.teltonika.sim.storedMatches": "Opgeslagen pincode in de router: klopt",
  "devices.teltonika.sim.storedDiffers": "Opgeslagen pincode in de router: klopt niet",
  "devices.teltonika.sim.storedUnknown": "Opgeslagen pincode in de router: onbekend",
  "devices.teltonika.sim.inactive": "Niet de actieve simkaart: de status is van toen hij voor het laatst actief was.",
  "devices.teltonika.sim.switchFirst": "Schakel eerst over naar deze simkaart",
  "devices.teltonika.sim.lockCompany": "Vergrendelen met bedrijfspincode",
  "devices.teltonika.sim.useOwn": "Eigen pincode gebruiken",
  "devices.teltonika.sim.change": "Pincode wijzigen",
  "devices.teltonika.sim.unlock": "Ontgrendelen",
  "devices.teltonika.sim.unblockPuk": "Deblokkeren met PUK-code",
  "devices.teltonika.sim.store": "Opgeslagen pincode in de router",
  "devices.teltonika.sim.currentPin": "De huidige pincode van de simkaart",
  "devices.teltonika.sim.carrierHint": "een nieuwe simkaart: de pincode van de provider",
  "devices.teltonika.sim.keptHint": "leeg: de pincode die Velanox bewaart",
  "devices.teltonika.sim.newPin": "Nieuwe pincode (4 tot 8 cijfers)",
  "devices.teltonika.sim.simPin": "De pincode van de simkaart",
  "devices.teltonika.sim.puk": "PUK-code (8 cijfers)",
  "devices.teltonika.sim.note": "Notitie",
  "devices.teltonika.sim.noteHint": "bijv. leen-simkaart van …",
  "devices.teltonika.sim.toCompany": "De bedrijfspincode gebruiken",
  "devices.teltonika.sim.lastTryConfirm": "Nog één poging. Een onjuiste pincode blokkeert de simkaart nu totdat de PUK-code is ingevoerd. Doorgaan?",
  "devices.teltonika.sim.doneSteps": "Gedaan: {steps}",
  "devices.teltonika.sim.failedStep": "Niet gedaan: {step}",
  "devices.teltonika.sim.step.change_pin": "pincode gewijzigd",
  "devices.teltonika.sim.step.check_on": "pincontrole aan",
  "devices.teltonika.sim.step.check_off": "pincontrole uit",
  "devices.teltonika.sim.step.unblock": "simkaart gedeblokkeerd",
  "devices.teltonika.sim.step.store": "opgeslagen pincode in de router ingesteld",
  "devices.teltonika.sim.step.read": "status gelezen",
  "devices.teltonika.sim.needsDirect": "Voor het wijzigen van de pincode is de directe of VPN-verbinding van de router nodig.",
  "devices.teltonika.sim.notRead": "De simkaart wordt bij de volgende synchronisatie gelezen.",
  "devices.teltonika.sim.pinTriesUnknown": "Resterende pinpogingen: onbekend",
  "devices.teltonika.sim.unknownTriesConfirm": "Het aantal resterende pogingen is niet te lezen: dit kan de laatste zijn, en een onjuiste pincode of PUK-code zou de simkaart blokkeren. Doorgaan?",
  "devices.teltonika.sim.lastPukConfirm": "Nog één PUK-poging. Een onjuiste PUK-code maakt de simkaart nu voorgoed onbruikbaar: alleen de provider kan hem vervangen. Doorgaan?",
  "devices.accessFix.teltonika": "Voer dit eenmalig uit op de router om de VPN-server van Velanox {serverIp} toegang te geven: in de WebUI onder System → Maintenance → CLI, of via SSH vanuit het eigen netwerk van de router.",
  "devices.accessFix.peplink": "De API heeft hiervoor geen aanroep: sta in de Web Admin van de router, onder System → Admin Security, HTTPS (poort 443) en het bronadres {serverIp} (de VPN-server van Velanox) toe op de verbinding die de VPN gebruikt.",
  "devices.accessFix.copy": "Opdracht kopiëren",
}

export default devices
